import React from "react";
import compose from "lodash/fp/compose";

import { Redirect } from "../../router";
import { withSubscribe, AuthContainer } from "../../state";

class C extends React.Component {
  componentDidMount() {
    const { auth } = this.props;
    auth.delAuth();
  }

  render() {
    const { auth } = this.props;

    if (auth.hasAuth()) {
      return null;
    }

    return <Redirect to="/" />;
  }
}

const LogoutScene = compose(withSubscribe({ to: { auth: AuthContainer } }))(C);

export default LogoutScene;
